import { render, staticRenderFns } from "./surgaltiinOrchin.vue?vue&type=template&id=f9727248&"
import script from "./surgaltiinOrchin.vue?vue&type=script&lang=js&"
export * from "./surgaltiinOrchin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports